<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/Reports">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ report_name }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("reports.label.outputType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="output type"
                >
                  <v-select
                    label="value"
                    :options="output"
                    v-model="ViewReports.outputType"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
              v-for="(item, i) in viewReport.data"
              :key="i"
            >
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">
                  {{ $t(item.row[2]) }} <span class="required">*</span>
                </small>

                <ValidationProvider
                  v-if="fieldTypes[getFieldType(item)]"
                  rules="required"
                  v-slot="{ errors }"
                  :name="item.row[0]"
                >
                  <component
                    :is="fieldTypes[getFieldType(item)].component"
                    v-bind="fieldTypes[getFieldType(item)].props(item)"
                    v-model="
                      ViewReports[
                        fieldTypes[getFieldType(item)].props(item).model
                      ]
                    "
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row center">
            <div class="vx-col w-full">
              <vs-button
                color="primary"
                :disabled="!validateRunReport"
                @click="getrecords()"
                >{{ $t("reports.label.runReports") }}</vs-button
              >
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card v-if="recordList.columnHeaders">
          <vs-table
            :max-items="descriptionItems[0]"
            :data="data"
            pagination
            description
            search
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header" v-if="billId">
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-download"
                  @click="downloadBill()"
                  size="small"
                  >{{ $t("Download Invoice") }}</vs-button
                >
              </div>
            </template>
            <template slot="header">
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-download"
                  @click="
                    downloadStatement(
                      report_name,
                      ViewReports.officeId,
                      ViewReports.startDate,
                      ViewReports.endDate,
                      ViewReports.clientId,
                      ViewReports.JobRunId
                    )
                  "
                  size="small"
                  >{{ $t("reports.label.exportPdf") }}</vs-button
                >
              </div>
            </template>
            <template slot="header">
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  color="success"
                  icon-pack="feather"
                  icon="icon-download"
                  @click="
                    downloadCSV(
                      report_name,
                      ViewReports.officeId,
                      ViewReports.startDate,
                      ViewReports.endDate,
                      ViewReports.clientId,
                      ViewReports.JobRunId
                    )
                  "
                  size="small"
                  >{{ $t("reports.label.exportCsv") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th
                class="vx-col w-full lg:w-1/12 md:w-1/12 sm:w-full xs:w-full"
                v-for="(item, i) in columnHeaders"
                :key="i"
              >
                {{ item.columnName }}</vs-th
              >
            </template>
            <template slot-scope="{ data }">
              <vs-tr
                class="vx-col w-full"
                :key="index"
                :data="data"
                v-for="(item, index) in data"
              >
                <vs-td v-for="(el, j) in item.row" :key="j"> {{ el }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletereportsPopup"
      title=" Reports"
      @deletePressed="deletereports()"
      @cancelPressed="deletereportsPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BUCKET_BASE_URL } from "@/http/index";
export default {
  data() {
    return {
      columnHeaders: [],
      data: [],
      report_name: "",
      breadcrumbs: [
        { name: "Reports", to: "/reports" },
        { name: this.$route.params.report_name, to: "/" },
      ],
      searchOption: 0,
      toggleTeam: true,
      descriptionItems: [10, 20, 30],
      deletePromotioncodePopup: false,
      delId: 0,
      id: "",
      ViewReports: {
        outputType: "",
      },
      editJobsPopup: false,
      billId: 0,
      output: ["Normal format", "CSV format", "PDF format", "Chart format"],
      redirectToEdit: false,
      deletereportsPopup: false,
      Entity: [],
      Payment: [],
      fieldTypes: {
        datepicker: {
          component: "datepicker",
          props: (item) => ({
            placeholder: `Select ${item.row[2]}`,
            model: item.row[1],
            format: this.formattedSelectDate,
            disabledDates:
              item.row[0] === "startDateSelect"
                ? {
                    from: this.ViewReports.startDate
                      ? new Date(this.ViewReports.startDate)
                      : new Date(),
                  }
                : {
                    to: this.ViewReports.endDate
                      ? new Date(this.ViewReports.endDate)
                      : null,
                  },
          }),
        },
        select: {
          component: "v-select",
          props: (item) => ({
            label: "label",
            options: this.getOptionsForSelect(item.row[0]),
            model: item.row[1],
            placeholder: `Select ${item.row[2]}`,
            reduce: (value) => value.id,
          }),
        },
        input: {
          component: "vs-input",
          props: (item) => ({
            type: "text",
            placeholder: `Enter ${item.row[2]}`,
            model: item.row[1],
          }),
        },
      },
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
  },
  computed: {
    ...mapState({
      viewReport: (state) => state.reports.Report,
      ReportDropDown: (state) => state.reports.list,
      Mode: (state) => state.reports.paymentlist,
      recordList: (state) => state.reports.Record,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    formattedSelectDate() {
      return this.convertDateFormat(this.formattedDate);
    },

    validateRunReport() {
      if (!this.ViewReports.outputType) return false;
      for (let i = 0; i < this.viewReport.data.length; i++) {
        let item = this.viewReport.data[i];
        let fieldType = this.getFieldType(item);
        switch (fieldType) {
          case "datepicker":
            if (!this.ViewReports[item.row[1]]) return false;
            break;
          case "select":
            if (!this.ViewReports[item.row[1]]) return false;
            break;
          case "input":
            if (!this.ViewReports[item.row[1]]) return false;
            break;
        }
      }
      return true;
    },
  },
  methods: {
    async emptyRecordList() {
      await this.$store.dispatch("reports/emptySetRecords", { data: [] });
    },
    getFieldType(item) {
      switch (item.row[0]) {
        case "startDateSelect":
        case "endDateSelect":
          return "datepicker";
        case "OfficeIdSelectOne":
        case "pmtModeSelectAll":
          return "select";
        default:
          return "input";
      }
    },
    getOptionsForSelect(fieldName) {
      switch (fieldName) {
        case "OfficeIdSelectOne":
          return this.Entity;
        case "pmtModeSelectAll":
          return this.Payment;
        default:
          return [];
      }
    },
    async getReport() {
      try {
        await this.$store.dispatch("reports/setReport", {
          Name: "'" + this.report_name + "'",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getDropdown() {
      try {
        await this.$store.dispatch("reports/setDropdown");
        this.Entity = this.ReportDropDown.data.map((item) => {
          let obj = { id: item.row[0], label: item.row[1] };
          return obj;
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getpaymentDropdown() {
      try {
        await this.$store.dispatch("reports/setpaymentDropdown");
        this.Payment = this.Mode.data.map((item) => {
          let obj = { id: item.row[0], label: item.row[1] };
          return obj;
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    downloadStatement(
      Header,
      officeid,
      startdate,
      enddate,
      clientId,
      jobRunId
    ) {
      const baseUrl =
        BUCKET_BASE_URL +
        `/runreports/${Header}?output-type=PDF&tenantIdentifier=default&locale=en&dateFormat=dd%20MMMM%20yyyy&exportPDF=true`;

      const params = {
        R_officeId: officeid,
        R_startDate: startdate,
        R_endDate: enddate,
        R_clientId: clientId,
        R_JobRunId: jobRunId,
      };

      const queryString = Object.entries(params)
        .filter(
          ([_, value]) => value !== undefined && value !== null && value !== ""
        )
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      this.downloadFile(
        baseUrl + (queryString ? `&${queryString}` : ""),
        `statement_${this.billId}.pdf`
      );
    },
    downloadCSV(Header, officeid, startdate, enddate, clientId, jobRunId) {
      const baseUrl =
        BUCKET_BASE_URL +
        `/runreports/${Header}?output-type=CSV&tenantIdentifier=default&locale=en&dateFormat=dd%20MMMM%20yyyy&exportCSV=true`;

      const params = {
        R_officeId: officeid,
        R_startDate: startdate,
        R_endDate: enddate,
        R_clientId: clientId,
        R_JobRunId: jobRunId,
      };

      const queryString = Object.entries(params)
        .filter(
          ([_, value]) => value !== undefined && value !== null && value !== ""
        )
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      // window.open(baseUrl + (queryString ? `&${queryString}` : ""));
      this.downloadFile(
        baseUrl + (queryString ? `&${queryString}` : ""),
        `statement_${this.billId}.csv`
      );
    },
    async downloadFile(fullLink, name) {
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(fullLink, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    async downloadBill() {
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(
          `${BUCKET_BASE_URL}/billmaster/${this.billId}/printProformaStatement?tenantIdentifier=default`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `statement_${this.billId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    async getrecords() {
      try {
        let reportData = { Header: this.report_name };
        this.viewReport.data.forEach((item) => {
          let fieldName = item.row[1];
          let fieldType = this.getFieldType(item);
          switch (fieldType) {
            case "datepicker":
              reportData[fieldName] = moment(
                this.ViewReports[fieldName]
              ).format("YYYY-MM-DD");
              break;
            case "select":
              reportData[fieldName] = this.ViewReports[fieldName];
              break;
            case "input":
              reportData[fieldName] = this.ViewReports[fieldName];
              break;
          }
        });
        await this.$store.dispatch("reports/setrecords", reportData);
        this.columnHeaders = this.recordList.columnHeaders;
        this.data = this.recordList.data;
        for (let i = 0; i < this.columnHeaders.length; i++) {
          let item = this.columnHeaders[i].columnName;
          if (item === "bill_id") {
            this.billId = this.data[0].row[i];
          }
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `API failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    convertDateFormat(format) {
      return format
        .replace(/Y+/g, (match) => match.toLowerCase())
        .replace(/D+/g, (match) => match.toLowerCase());
    },
  },
  mounted() {
    this.report_name = this.$route.params.report_name;
    this.getReport();
    this.getDropdown();
    this.getpaymentDropdown();
  },
  beforeDestroy() {
    this.emptyRecordList();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
